import { chakra } from '@stockx/ui';

export const PriceLineWrapper = chakra('div', {
  baseStyle: {
    fontSize: ['24px', '35px'],
    lineHeight: [8, 9],
    fontWeight: 600,
  },
});

const baseMarketArrowStyles = {
  display: 'inline-block',
  width: 0,
  height: 0,
  borderStyle: 'solid',
};

export const MarketArrowStyles = {
  variants: {
    up: {
      ...baseMarketArrowStyles,
      borderWidth: '0 5.5px 10.9px 5.5px',
      borderColor: 'transparent',
      borderBottomColor: 'green.700',
      '@media (min-width: @screen-md-min)': {
        borderWidth: '0 7px 13.9px 7px',
      },
    },
    down: {
      ...baseMarketArrowStyles,
      borderWidth: '10.9px 5.5px 0 5.5px',
      borderColor: 'transparent',
      borderTopColor: 'red.700',
      '@media (min-width: @screen-md-min)': {
        borderWidth: '13.9px 7px 0 7px',
      },
    },
  },
};

const basePricelineStatStyles = {
  fontSize: '12px',
  lineHeight: 3,
  textTransform: 'uppercase',
  letterSpacing: '1px',
};

export const PricelineStatStyles = {
  variants: {
    home: {
      ...basePricelineStatStyles,
      height: 5,
    },
    browse: {
      ...basePricelineStatStyles,
      display: 'flex',
      marginTop: 0,
      height: 12,
      flexDirection: { base: 'column', sm: 'row' },
      alignItems: 'center',
      justifyContent: { base: 'center', sm: 'flex-start' },
      width: '100%',
    },
  },
};
